<template>
  <span>
    <router-link :to="{ name: 'home' }">
      <v-btn v-if="!isLoggedIn" right dark color="grey darken-3">
        Log in <v-icon icon right>mdi-login-variant</v-icon>
      </v-btn>
    </router-link>

    <div v-if="isLoggedIn">
      <v-btn
        class="p-0 m-0"
        text
        icon
        color="grey darken-2"
        @click="setLeftHanded(!leftHanded)"
      >
        <v-icon title="Left Handed" v-if="leftHanded">mdi-hand-left</v-icon>
        <v-icon title="Right Handed" v-else>mdi-hand-right</v-icon>
      </v-btn>

      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-music-accidental-sharp</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item-group>
            <v-list-item
              v-for="(tuning, i) in tunings"
              :key="i"
              @click="setTuning(tuning.spec)"
            >
              <v-list-item-content>
                <v-list-item-title
                  v-text="tuning.name + ' tuning'"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <router-link :to="{ name: 'account' }">
        <v-btn text small class="d-none d-sm-inline">
          {{ currentUser.first_name || currentUser.email }}
        </v-btn>
      </router-link>

      <v-btn text icon right color="grey darken-2" @click="logoutClicked()">
        <v-icon title="Log out">mdi-logout-variant</v-icon>
      </v-btn>
    </div>
  </span>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { Tunings } from "fretboards";

export default {
  name: "UserMenu",
  data: () => ({
    tunings: [
      { name: "standard", spec: Tunings.guitar6.standard },
      { name: "4ths", spec: Tunings.guitar6.E_4ths }
    ]
  }),
  computed: {
    ...mapGetters("accounts", ["isLoggedIn", "currentUser"]),
    ...mapState("preferences", ["leftHanded", "tuning"])
  },
  methods: {
    ...mapActions("accounts", ["logout"]),
    ...mapActions("preferences", ["setLeftHanded", "setTuning"]),
    async logoutClicked() {
      await this.logout();
      this.$router.push("/");
    }
  }
};
</script>
